import _objectWithoutProperties from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "id", "children", "onDragOverClassName", "dropHandler", "htmlDirContentParams", "extraProps"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { getFilesFromDragEvent } from "html-dir-content";
import { useUploadyContext, markAsUploadOptionsComponent } from "@rpldy/shared-ui";
var UploadDropZone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      id = _ref.id,
      children = _ref.children,
      onDragOverClassName = _ref.onDragOverClassName,
      dropHandler = _ref.dropHandler,
      htmlDirContentParams = _ref.htmlDirContentParams,
      extraProps = _ref.extraProps,
      uploadOptions = _objectWithoutProperties(_ref, _excluded);

  var _useUploadyContext = useUploadyContext(),
      upload = _useUploadyContext.upload;

  var containerRef = useRef(null);
  var dragLeaveTrackerRef = useRef(false);
  useImperativeHandle(ref, function () {
    return containerRef.current;
  }, []); //using ref so upload can stay memoized

  var uploadOptionsRef = useRef();
  uploadOptionsRef.current = uploadOptions;
  var handleEnd = useCallback(function () {
    dragLeaveTrackerRef.current = false;

    if (containerRef.current && onDragOverClassName) {
      containerRef.current.classList.remove(onDragOverClassName);
    }
  }, [onDragOverClassName, containerRef]);
  var dropFileHandler = useCallback(function (e) {
    return dropHandler ? Promise.resolve(dropHandler(e)) : getFilesFromDragEvent(e, htmlDirContentParams || {});
  }, [dropHandler, htmlDirContentParams]);
  var handleDropUpload = useCallback(function (e) {
    dropFileHandler(e).then(function (files) {
      upload(files, uploadOptionsRef.current);
    });
  }, [upload, dropFileHandler, uploadOptionsRef]);
  var onDragEnter = useCallback(function (e) {
    dragLeaveTrackerRef.current = !dragLeaveTrackerRef.current && e.target === containerRef.current;

    if (containerRef.current && onDragOverClassName) {
      containerRef.current.classList.add(onDragOverClassName);
    }
  }, [onDragOverClassName, containerRef]);
  var onDragOver = useCallback(function (e) {
    //must have drag over event handler with preventDefault for drop to work
    e.preventDefault();
  }, []);
  var onDrop = useCallback(function (e) {
    e.preventDefault();
    e.persist();
    handleEnd();
    handleDropUpload(e);
  }, [handleEnd, handleDropUpload]);
  var onDragLeave = useCallback(function (e) {
    if (dragLeaveTrackerRef.current && e.target === containerRef.current) {
      handleEnd();
    }
  }, [handleEnd, containerRef]);
  var onDragEnd = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    handleEnd();
  }, [handleEnd]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: className,
    ref: containerRef,
    onDragOver: onDragOver,
    onDragEnter: onDragEnter,
    onDrop: onDrop,
    onDragLeave: onDragLeave,
    onDragEnd: onDragEnd
  }, extraProps), children);
});
markAsUploadOptionsComponent(UploadDropZone);
export default UploadDropZone;